/** 受信任系统和外部编号（第二阶段 P2-4）：与 import-zh.ts 并列。 */
export default {
  trustedSystems: {
    title: '受信任系统',
    description: '由这些系统签名的案件包将被视为来自该系统。每个系统都会以密钥列表的形式发布其签名密钥。',
    empty: '尚无受信任系统。',
    add: '添加受信任系统',
    edit: '编辑',
    remove: '删除',
    removeConfirm: '删除 {{system}}？其案件包将无法再在此处验证。',
    confirmRemove: '删除系统',
    cancel: '取消',
    save: '保存',
    saved: '受信任系统已保存。',
    dialogTitle: '受信任系统',
    systemId: '系统编号',
    systemIdTaken: '已有使用此编号的受信任系统：请改为编辑它。',
    systemIdHint: '您为该系统起的简短名称，使用小写字母，例如 mbjb-osc。转交时会使用此名称。',
    name: '名称',
    keySource: '签名密钥',
    keySourceUrl: '从该系统的密钥列表地址获取',
    keySourceJwks: '粘贴密钥列表',
    jwksUrl: '密钥列表地址',
    jwksUrlHint: '该系统提供给您的 https 地址，例如其 /planning/jwks 地址。',
    jwks: '密钥列表（JSON）',
    jwksHint: '该系统发给您的密钥列表文件。',
    jwksAgain: '请重新粘贴密钥列表：保存时会整体替换。',
    requireSeal: '对此系统持有的申请要求案件包必须签名',
    kids: '密钥编号',
    withheldKids:
      '已暂停：{{kids}}。另一个受信任系统也发布了这些密钥，因此此条目不使用它们进行验证。如果这些密钥属于此系统，请保存此条目以认领它们。',
    fetchedAt: '密钥获取于 {{date}}',
    importTitle: '导入的案件包',
    importRequireSeal: '拒绝未经受信任系统签名的案件包',
    importRequireSealHint:
      '默认开启。未签名的案件包，或以您的受信任系统均未发布的密钥签名的案件包，将被拒绝。关闭后，此类案件包将作为无法更新的只读副本导入，并附带警告；它绝不会接管申请。',
    importRequireSealOff: '未经任何受信任系统签名的案件包将作为只读副本被接受。导入前请核实案件包的来源。',
    ruleOn: '每个导入的案件包都必须由这些系统之一签名（见上方“导入的案件包”）。',
    ruleOff:
      '未经这些系统签名的案件包将作为只读副本导入，除非持有该申请的系统要求案件包必须签名（见上方“导入的案件包”）。',
    ruleOnEmpty: '尚无受信任系统：只要“拒绝未经受信任系统签名的案件包”处于开启状态，每个导入的案件包都会被拒绝。',
    reasons: {
      body: '请检查各字段后重试。',
      system_id: '请使用小写字母、数字、短横线或下划线；“unverified”、“constructor”和“prototype”为保留名称。',
      name: '请输入不超过 200 个字符的名称。',
      key_source: '请提供密钥列表地址或粘贴的密钥列表，二者只能选一。',
      jwks: '该密钥列表不是有效的 Ed25519 公钥列表。',
      private_key: '该密钥列表包含私钥。请只粘贴公钥。',
      kid_mismatch: '某个密钥编号与其密钥不符。',
      kid_taken: '另一个受信任系统已在使用其中一个密钥。',
      limit: '最多只能信任 100 个系统。',
      jwks_url_invalid: '地址必须是不含用户名的 https 地址。',
      jwks_url_blocked: '不允许从此处获取该地址。',
      jwks_unreachable: '无法获取密钥列表。',
      jwks_too_large: '密钥列表过大。',
      jwks_invalid: '该地址未返回有效的密钥列表。',
    },
  },
  externalIds: {
    title: '外部编号',
    intro: '其他系统为此申请分配的编号，例如 OSC 申请编号（osc3plus:id_permohonan）。',
    empty: '没有外部编号。',
    scheme: '编号类型',
    schemeHint: '编号的类型，例如 osc3plus:id_permohonan 或 osc3plus:id_projek。',
    issuer: '签发方',
    value: '编号',
    link: '关联编号',
    linked: '编号已关联。',
    imported: '来自导入',
    origin: '从 {{system}} 导入（其编号 {{ref}}）。',
    originUnverified: '从未经验证的系统导入（其编号 {{ref}}）。',
  },
}
